import {z} from '@hono/zod-openapi';

export const serviceOrderCampaignPathSchema = z
  .object({
    serviceCaseId: z.string().uuid().openapi({example: '40b47967-97a9-4206-a3ea-d8656c97dd77'}),
    serviceOrderId: z.string().uuid().openapi({example: 'a858485d-0687-4fc3-a1d8-8220cc1e8568'}),
  })
  .openapi('ServiceOrderCampaignPath');
